import React from 'react'
import styled from 'styled-components'
import { Color, Colors } from '../styles/Colors';

const Button = styled.button`
    border: none; 
    background-color: ${({$theme}) => (($theme === 'darkBlue') ? Color(Colors.white) : Color(Colors.blue))};
    color: ${({$theme}) => (($theme === 'darkBlue') ? Color(Colors.blue) : Color(Colors.white))};

    border-radius: 4px;
    padding: 0.5rem; 
    align-self: center;
    padding: 0.75rem; 
    width: 100%; 
    margin: 0 0 1rem 0; 
    font-weight: 600; 
        
    &:hover {
        background-color: ${
            ({$theme}) => (
                ($theme === 'darkBlue') 
                    ? Color(Colors.lightBlue) 
                    : ($theme === 'lightBlue') 
                        ? Color(Colors.white) 
                        : Color(Colors.lightBlue))
        };
        color: ${
            ({$theme}) => (
                ($theme === 'darkBlue') 
                    ? Color(Colors.white) 
                    : ($theme === 'lightBlue') 
                        ? Color(Colors.blue) 
                        : Color(Colors.white)
        )};
    }
`;

const AddInputBtn = ({item, setItem, label, theme}) => {
    const handleAddInput = (event) => {
        event.preventDefault()
        setItem({
            ...item,
            document_links: [...item.document_links, { fileName: '', url: ''}]
        })
    }

  return (
    <Button $theme={theme} type='button' onClick={handleAddInput}>{label}</Button>
  )
}

export default AddInputBtn
